const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/reducers/labReports/loadLabSingleReportsHandlers.ts';
import Imm from 'immutable';
import { incCounter, decCounter } from '../../utils/reducerUtils';
import { IKisApiHandlersMap } from '../../defs/actionTypes';
import { LoadLabSingleRepsAction } from '../../actions/labReportsActions';
import { Logger } from '../../services/KisLoggerService';
import { putLabSingleRepIntoState } from '../../utils/labReportUtils';

const Log = Logger('labReports/loadLabSingleReports');

export const loadLabSingleReportsHandlers: IKisApiHandlersMap<LoadLabSingleRepsAction> = {
    pending: (state, action) => {
        return incCounter(state, ['loading', 'singleReports', action.meta.patnr]);
    },
    success: (state, action) => {
        const payload: any = action && action.payload ? action.payload : {};
        const list: any[] = Array.isArray(payload.List) ? payload.List : [];

        list.forEach(item => {
            const rec = Imm.fromJS(item);

            if (action.meta.evenIfDeleted || rec.get('STATUS') !== 'I') {
                state = putLabSingleRepIntoState(state, rec, action.meta.patnr);
            }
        });

        return decCounter(state, ['loading', 'singleReports', action.meta.patnr]);
    },
    failure: (state, action) => {
        Log.warn('Failed to load the list of lab single reports', action);
        return decCounter(state, ['loading', 'singleReports', action.meta.patnr]);
    },
};
